import type { Statemachine } from 'overmind';
import { statemachine } from 'overmind';

import type { Params } from '../effects/router';

type ValidRoutes = Record<
  | 'root'
  | 'rootWithTenantId'
  | 'executeCalculationSetUsing'
  | 'calculationv2'
  | 'unauthorized'
  | 'signInArcgis'
  | 'configurationV2',
  `/${string}` | '/'
>;

export const routes: ValidRoutes = {
  root: '/',
  rootWithTenantId: '/:tenantId',
  executeCalculationSetUsing: '/execute-calculation-set-using',
  calculationv2: '/calculation-v2',
  unauthorized: '/unauthorized',
  signInArcgis: '/signin-arcgis',
  configurationV2: '/configuration-v2'
} as const;

export type Route = keyof typeof routes;

type States =
  | {
      current: 'VALID_PAGE';
    }
  | {
      current: 'PAGE_NOT_FOUND';
    };

type BaseState = {
  currentRoute: Route;
  params: Params;
};

export type ChangeRoutePayload = {
  route: Route;
  params?: Params;
};

type Events =
  | {
      type: 'CHANGE_ROUTE';
      data: ChangeRoutePayload;
    }
  | {
      type: 'NOT_FOUND_ROUTED';
    };

export type RouterMachine = Statemachine<States, Events, BaseState>;

export const routerMachine = statemachine<States, Events, BaseState>({
  VALID_PAGE: {
    CHANGE_ROUTE: ({ route, params = {} }, { current }) => ({
      current,
      currentRoute: route,
      params
    }),
    NOT_FOUND_ROUTED: () => ({
      current: 'PAGE_NOT_FOUND'
    })
  },
  PAGE_NOT_FOUND: {
    CHANGE_ROUTE: ({ route, params = {} }) => ({
      current: 'VALID_PAGE',
      currentRoute: route,
      params
    })
  }
});

export const createRouterMachine = () => {
  return routerMachine.create(
    { current: 'VALID_PAGE' },
    {
      currentRoute: 'root',
      params: {}
    }
  );
};
